export class LeagueRequestDto implements ILeagueRequestDto{
    name: string;
    email: string;
    phone: string;
    skill: string;
    comment: string;
    leagueName: string;
    session: ISessionDto;
}